// iter87.199.163 — Single source of truth for "boost-only" templates
// (Matchday Boost/Weekly Spread IS the entire game surface — no draft,
// no pot picks, no Champion, no Power Pick). Mirrors the backend's
// `tournament_helpers.BOOST_ONLY_TEMPLATES`. Every dashboard/admin
// component that needs to special-case these templates MUST import
// this constant instead of re-listing the keys inline — a prior
// session found the drift (ScoringTab.jsx) caused a real UI bug when
// EPL/La Liga Weekly Spread was added without updating every literal.
export const BOOST_ONLY_TEMPLATES = new Set([
    "nfl_boost_api",
    "epl_boost_api",
    "la_liga_boost_api",
]);

export const isBoostOnlyTemplate = (template) => BOOST_ONLY_TEMPLATES.has(template);
